import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { useSmoothScroll } from './hooks/useSmoothScroll';
interface AppProps {
  emotion?: 'auto' | 'neutral' | 'curious' | 'happy' | 'angry' | 'sad' | 'sleepy' | 'surprised';
  screenScale?: number;
  /** Which side of the model carries the face — "auto" detects it */
  faceSide?: 'auto' | 'front' | 'back' | 'left' | 'right' | 'top';
  /** Side plates: tuck in on their own ("auto"), or hold them open / closed */
  armsMode?: 'auto' | 'open' | 'closed';
}
export function App({
  emotion = 'auto',
  screenScale = 0.78,
  faceSide = 'auto',
  armsMode = 'auto'
}: AppProps) {
  useSmoothScroll();
  return <BrowserRouter data-id="element-0" data-mp="2whx9joashed2">
      <Routes data-id="element-1" data-mp="28ufqch5lbolp">
        <Route path="/legal" element={<Legal data-id="element-3" data-mp="28te3zgj4jfoo" />} data-id="element-2" data-mp="28u5vaf5our95" />
        <Route path="*" element={<Home emotion={emotion} screenScale={screenScale} faceSide={faceSide} armsMode={armsMode} data-id="element-5" data-mp="23vkuadim43jn" />} data-id="element-4" data-mp="28sl3gxardmez" />
      </Routes>
    </BrowserRouter>;
}